import React, {useCallback} from 'react'
import ListItemText from '@mui/material/ListItemText'
import ListItem from '@mui/material/ListItem'
import StyledCheckbox from '@/components/pages/NewDatasetJobPage/StyledCheckbox'
import {Switch} from '@mui/material'
import {BoolFilterOptions} from '@/components/pages/NewDatasetJobPage/types'
import FractionNonMissingTooltip from '@/components/common/FractionNonMissingTooltip'

type BooleanFilterItemProps = {
    boolFilterOpts: BoolFilterOptions
    checked: boolean
    onFilterSelect: (filterName: string, checked: boolean, filterVal: boolean) => void
    filterValue: boolean
}

const BooleanFilterItem = ({boolFilterOpts, checked, onFilterSelect, filterValue = false}: BooleanFilterItemProps) => {

    const handleSwitchChange = useCallback((evt: any) => {
        onFilterSelect(boolFilterOpts.name, true, evt.target.checked)
    }, [boolFilterOpts])

    return (
        <ListItem disablePadding>
            <StyledCheckbox checked={checked} onClick={() => onFilterSelect(boolFilterOpts.name, !checked, false)}/>
            <FractionNonMissingTooltip fraction={boolFilterOpts.fraction_non_missing}>
                <ListItemText primary={boolFilterOpts.name}/>
            </FractionNonMissingTooltip>
            <Switch checked={filterValue} onChange={handleSwitchChange}/>
        </ListItem>
    )
}

export default BooleanFilterItem